import network from '@/services/network';

/**
 * Gesellschaften (BER-67). `active` liefert die aktiven Gesellschaften für den
 * Antrags-Wizard (jeder eingeloggte User); die übrigen Endpunkte sind die
 * Admin-Verwaltung (nur `application-providers.manage`).
 *
 * Sortierung kommt vom Backend: Favoriten zuerst (alphabetisch), dann der Rest
 * alphabetisch.
 */
export interface ApplicationProvider {
  id: number;
  value: string;
  label: string;
  is_favorite: boolean;
  is_active: boolean;
  /** Max. Beitragszahldauer (Jahre) für die BWS-Berechnung. Standard 40. */
  max_years: number;
  /** Boniprüfung läuft bei dieser Gesellschaft automatisch im Wizard. */
  braucht_bonicheck: boolean;
  updated_at?: string;
  /** IDs der zugeordneten Antragstypen (Admin-Zuordnung). */
  type_ids?: number[];
  /** `value`s der zugeordneten Antragstypen (Wizard-Filter). */
  type_values?: string[];
}

export interface ApplicationProviderInput {
  value: string;
  label: string;
  is_favorite?: boolean;
  is_active?: boolean;
  /** Max. Beitragszahldauer (Jahre) für die BWS-Berechnung. */
  max_years?: number;
  braucht_bonicheck?: boolean;
  /** Wenn gesetzt: synchronisiert die zugeordneten Antragstypen (IDs). */
  type_ids?: number[];
}

const getActive = async (): Promise<ApplicationProvider[]> => {
  const { data } = await network.get<{ data: ApplicationProvider[] }>('/application-providers/active');
  return data.data;
};

const getAll = async (): Promise<ApplicationProvider[]> => {
  const { data } = await network.get<{ data: ApplicationProvider[] }>('/application-providers');
  return data.data;
};

const create = async (input: ApplicationProviderInput): Promise<ApplicationProvider> => {
  const { data } = await network.post<{ data: ApplicationProvider }>('/application-providers', input);
  return data.data;
};

const update = async (
  id: number,
  input: Partial<ApplicationProviderInput>,
): Promise<ApplicationProvider> => {
  const { data } = await network.put<{ data: ApplicationProvider }>(`/application-providers/${id}`, input);
  return data.data;
};

const remove = async (id: number): Promise<void> => {
  await network.delete(`/application-providers/${id}`);
};

const applicationProvider = { getActive, getAll, create, update, remove };

export default applicationProvider;
